var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 18 18" }, props),
    React.createElement("path", { fill: "currentColor", d: "M8.57 15.5L4.78 17.3a1 1 0 0 1-1.42-1.032l.543-4.161a1 1 0 0 0-.266-.817L.752 8.244a1 1 0 0 1 .543-1.671l4.125-.77a1 1 0 0 0 .695-.504l2.007-3.686a1 1 0 0 1 1.756 0l2.007 3.686a1 1 0 0 0 .695.504l4.125.77a1 1 0 0 1 .543 1.67l-2.885 3.048a1 1 0 0 0-.266.817l.543 4.161a1 1 0 0 1-1.42 1.032L9.43 15.5a1 1 0 0 0-.86 0z" })
  );
});